import { callBackendApi } from "../../../../components/service/axios";

export const previewGroupMembership = async (userGroupUniqueName, page, size, change, payload) => {
  return await callBackendApi(
    "patch",
    "/bff/user-groups/" + userGroupUniqueName + "/membership/preview",
    payload,
    {
      page: page,
      size: size,
      change: change,
    }
  );
};
